import { siteConfig } from "../data/siteConfig";

const PREVIEW_KEY = "liftoff-preview-launch";
const PREVIEW_DAYS = 30;

/** Resolves the countdown target. Uses siteConfig.launchDate when set. */
export function getLaunchTarget(): Date {
  if (siteConfig.launchDate) {
    const configured = new Date(siteConfig.launchDate);
    if (!Number.isNaN(configured.getTime())) return configured;
  }

  // Temporary preview target until a real launch date is configured.
  try {
    const stored = window.localStorage.getItem(PREVIEW_KEY);
    if (stored) {
      const parsed = new Date(stored);
      if (!Number.isNaN(parsed.getTime()) && parsed.getTime() > Date.now()) return parsed;
    }
    const preview = new Date(Date.now() + PREVIEW_DAYS * 24 * 60 * 60 * 1000);
    window.localStorage.setItem(PREVIEW_KEY, preview.toISOString());
    return preview;
  } catch {
    return new Date(Date.now() + PREVIEW_DAYS * 24 * 60 * 60 * 1000);
  }
}
